import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService, DashboardStore } from '@app/shared/data';
import { environment } from '@env';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

@Component({
  selector: 'app-toolbar',

  imports: [CommonModule, RouterModule, ButtonModule, AvatarModule, MenuModule, NgOptimizedImage],
  templateUrl: './toolbar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
  private readonly _authService = inject(AuthService);

  private readonly _dashboardStore = inject(DashboardStore);

  readonly businessName: string = environment.businessInfo.name;

  readonly logoPath: string = environment.businessInfo.logoPath;

  readonly enablePublicSignup: boolean = environment.businessInfo.enablePublicSignup;

  isSidebarOpen = this._dashboardStore.isSidebarOpen;

  user$ = this._authService.user$;

  menuItems: { label: string; fragment: string; icon: string }[] = [
    {
      label: 'Pricing',
      fragment: 'pricing',
      icon: 'pi pi-credit-card',
    },
    {
      label: 'Contact',
      fragment: 'contact',
      icon: 'pi pi-envelope',
    },
  ];

  userMenuItems: MenuItem[] = [
    {
      label: 'Account',
      icon: 'pi pi-user',
      routerLink: '/dashboard/settings/profile',
    },
    {
      label: 'Sign Out',
      icon: 'pi pi-sign-out',
      command: (): void => {
        this.signOut();
      },
    },
  ];

  /**
   * Handles a menu item click
   * @param item The menu item that was clicked
   */
  handleMenuClick(item: MenuItem): void {
    // Execute the item's command if it exists
    if (item.command) {
      item.command({});
    }
    // Close the sidebar
    this.closeSidebar();
  }

  /**
   * Toggles the open state of the sidebar
   */
  toggleSidebar(): void {
    this._dashboardStore.toggleSidebar();
  }

  /**
   * Closes the sidebar
   */
  closeSidebar(): void {
    this._dashboardStore.closeSidebar();
  }

  /**
   * Signs a user out
   */
  signOut(): void {
    this._authService.logout();
  }
}
